export const BodyprintMode = Object.freeze({
  NONE: "none",
  VIEW: "view",
  EDIT: "edit"
});
